"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
class RuleEvent extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'ruleEvent';
        this._event = initParams.event;
        this._time = initParams.time;
    }
    set event(value) {
        console.error('Do not set objects this way');
    }
    get event() {
        return this._event;
    }
    set time(value) {
        console.error('Do not set objects this way');
    }
    get time() {
        return this._time;
    }
}
exports.default = RuleEvent;
//# sourceMappingURL=ruleEvent.js.map